export default "__VITE_ASSET__BJsfRfb4__"